import { render } from "./VerseSelect.vue?vue&type=template&id=3d7cb65a&ts=true"
import script from "./VerseSelect.vue?vue&type=script&lang=ts"
export * from "./VerseSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__